/* Editorial enhancement only. Content, links and native details work without JS. */
(function () {
  'use strict';
  if (!document.querySelector('[data-v7-product]')) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var images = Array.from(document.querySelectorAll('.v7-experience [data-v7-image-motion]'));
  var reveals = Array.from(document.querySelectorAll('.v7-experience [data-v7-reveal]'));
  var navLinks = Array.from(document.querySelectorAll('.v7-section-nav a'));
  var scheduled = false;
  var revealObserver;

  // Never set opacity, visibility or display: every message stays readable.
  function revealEverything() {
    reveals.forEach(function (node) { node.classList.add('v7-in-view'); });
  }

  if (!reduced.matches && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('v7-in-view');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });
    reveals.forEach(function (node) {
      node.classList.add('v7-reveal-ready');
      revealObserver.observe(node);
    });
  } else revealEverything();

  function update() {
    scheduled = false;
    var height = window.innerHeight || document.documentElement.clientHeight;
    images.forEach(function (node) {
      if (reduced.matches) {
        node.style.removeProperty('--v7-image-offset');
        node.style.removeProperty('--v7-image-scale');
        return;
      }
      var rect = node.getBoundingClientRect();
      if (rect.bottom < -20 || rect.top > height + 20) return;
      var progress = Math.max(0, Math.min(1, (height - rect.top) / (height + rect.height)));
      node.style.setProperty('--v7-image-scale', (1.045 - Math.min(1, progress * 1.5) * 0.045).toFixed(4));
      // A small, real vertical movement: no 3D simulation or image distortion.
      node.style.setProperty('--v7-image-offset', ((progress - 0.5) * 20).toFixed(2) + 'px');
    });
    var current;
    navLinks.forEach(function (link) {
      var target = document.getElementById(link.hash.slice(1));
      if (target && target.getBoundingClientRect().top <= height * 0.45) current = link;
    });
    navLinks.forEach(function (link) {
      if (link === current) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }

  function requestUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }

  // A linked contents/ingredient accordion opens before its anchor is visited.
  function openLinkedDetail(hash) {
    if (!hash || hash.length < 2) return;
    var id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
    var target = document.getElementById(id);
    if (!target || !target.closest('.v7-experience')) return;
    var detail = target.matches('details') ? target : target.closest('details');
    if (detail) detail.open = true;
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href^="#"]');
    if (link) openLinkedDetail(link.hash);
  });
  window.addEventListener('hashchange', function () { openLinkedDetail(window.location.hash); });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.querySelectorAll('.v7-experience details').forEach(function (detail) {
    detail.addEventListener('toggle', requestUpdate);
  });
  function motionChanged() {
    if (reduced.matches) {
      if (revealObserver) revealObserver.disconnect();
      revealEverything();
    }
    requestUpdate();
  }
  if (reduced.addEventListener) reduced.addEventListener('change', motionChanged);
  else if (reduced.addListener) reduced.addListener(motionChanged);
  openLinkedDetail(window.location.hash);
  requestUpdate();
}());
